// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import exportFromJSON from 'export-from-json';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, sprintf } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-download-log' )
export class AutomatorLogHeaderActionDownloadLog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The object that will be sent to the user
	@property( { type: String, attribute: 'recipe-title' } ) accessor recipeTitle;

	@property( { type: Object, attribute: false } ) accessor downloadObject = {};

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ escapeHTML( __( 'Download this log entry', 'uncanny-automator' ) ) }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					@click=${ this.downloadJSON }
				>
					<uo-icon id="download" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}

	/**
	 * Downloads the file
	 */
	downloadJSON() {
		if ( isEmpty( this.downloadObject ) ) {
			return;
		}

		// Export the main object
		exportFromJSON( {
			data: this.downloadObject,
			fileName: sprintf(
				/* translators: 1. The recipe name */
				escapeHTML( __( 'Log %1$s', 'uncanny-automator' ) ),
				this.recipeTitle
			).replace( /\s/g, '_' ),
			exportType: 'json'
		} );
	}
}